import { format, isValid, parseISO } from 'date-fns';

/**
 * Formatea una fecha a formato dd/mm/yyyy
 * @param date - Fecha como string (ISO) o Date
 * @returns Fecha formateada como dd/mm/yyyy o '--' si la fecha es inválida
 */
export const formatDateDDMMYYYY = (date: string | Date | null | undefined): string => {
  if (!date) return '—';

  try {
    let dateObj: Date;

    if (typeof date === 'string') {
      dateObj = parseISO(date);
    } else {
      dateObj = date;
    }

    if (!isValid(dateObj)) {
      return '—';
    }

    return format(dateObj, 'dd/MM/yyyy');
  } catch (error) {
    console.warn('Error formatting date:', date, error);
    return '—';
  }
};

/**
 * Formatea una fecha a formato dd/mm/yyyy HH:mm
 * @param date - Fecha como string (ISO) o Date
 * @returns Fecha formateada como dd/mm/yyyy HH:mm o '--' si la fecha es inválida
 */
export const formatDateTimeDDMMYYYY = (date: string | Date | null | undefined): string => {
  if (!date) return '—';

  try {
    let dateObj: Date;

    if (typeof date === 'string') {
      dateObj = parseISO(date);
    } else {
      dateObj = date;
    }

    if (!isValid(dateObj)) {
      return '—';
    }

    return format(dateObj, 'dd/MM/yyyy HH:mm');
  } catch (error) {
    console.warn('Error formatting date:', date, error);
    return '—';
  }
};
